// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.level-transition {
  animation-duration: 260ms;
  animation-timing-function: ease-out;
}

@keyframes levelEnterUp {
  from { transform: translateY(16px); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
}
@keyframes levelEnterDown {
  from { transform: translateY(-16px); opacity: 0; }
  to   { transform: translateY(0);     opacity: 1; }
}
.level-enter-up   { animation-name: levelEnterUp; }
.level-enter-down { animation-name: levelEnterDown; }
`, "",{"version":3,"sources":["webpack://./src/styles/vertical-carousel.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,OAAO,wBAAwB,KAAK,UAAU,EAAE;AAClD;AACA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,OAAO,wBAAwB,MAAM,UAAU,EAAE;AACnD;AACA,oBAAoB,4BAA4B,EAAE;AAClD,oBAAoB,8BAA8B,EAAE","sourcesContent":[".level-transition {\n  animation-duration: 260ms;\n  animation-timing-function: ease-out;\n}\n\n@keyframes levelEnterUp {\n  from { transform: translateY(16px); opacity: 0; }\n  to   { transform: translateY(0);    opacity: 1; }\n}\n@keyframes levelEnterDown {\n  from { transform: translateY(-16px); opacity: 0; }\n  to   { transform: translateY(0);     opacity: 1; }\n}\n.level-enter-up   { animation-name: levelEnterUp; }\n.level-enter-down { animation-name: levelEnterDown; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
